/*
  KP: two small touches to the buy area on phone case pages.

  A. Price on the Add to Cart button, on pages that have the "Product / Bundles" tabs
     (see assets/kp-bundles.js). The button reads, for example, "Add to cart \u00b7 \u00a335.99",
     like the "Add bundle to cart" button in the Bundles tab.

     The price is the one shown under the product title, so it always matches the model
     and case type chosen. It is not typed into the button: it is kept in a hidden note on
     the button's label ("data-kp-price") and drawn after the words by the one style rule
     at the bottom of this file. That way the theme's own button text is left alone (the
     theme re-writes it on every change, and the phone "Add to Cart" bar copies it).

     The button changes at the same moment as the price under the title: the note is
     re-written straight away whenever the price or the button changes, before the screen
     is next drawn, and it stays on while the theme is still loading the new choice in
     the background (the button is switched off for that moment, but keeps its price).

     Case type cards: each card already shows its own price, so when one is pressed that
     price is put under the title (and so on the button) at once, instead of about a
     second later when the picker has asked the store. The picker then writes the same
     price again.

     No price is added when the tabs are not showing, or when the button says "Sold out"
     or "Unavailable".

  B. A shorter "Double-check" note above Add to Cart, on every phone case page (products
     with a Case Type option). The theme's note reads "Double-check your phone type & case
     type before proceeding." and takes two lines on a phone; it is re-written here as
     NOTE_HTML below, which fits on one. The note itself lives in each phone case product
     template (a text block), and there are several of those templates, so the words are
     swapped on the page instead of being edited in every template. To change the wording,
     change NOTE_HTML. To go back to the templates' own words, set NOTE_HTML to ''.

  Loaded by snippets/theme-globals.liquid. Delete that line to switch both off.
*/
(function () {
  var NOTE_HTML = 'Double-check your <strong>phone model</strong> and <strong>case type</strong>.';

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function clean(text) {
    return String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function start(blocks) {
    if (blocks.kpAtcPrice) return;

    var form = blocks.querySelector('form[data-product-form]');
    if (!form || !blocks.querySelector('.product__variants-wrapper')) return;
    blocks.kpAtcPrice = true;

    var isCase = !!blocks.querySelector('select[name="options[Case Type]"]');

    // B. The shorter note. Only the text block that comes before the buy buttons and
    // starts with "Double-check" is touched, and only once.
    function shortenNote() {
      if (!isCase || !NOTE_HTML) return;

      each(blocks.children, function (node) {
        if (node.kpNote || !node.classList.contains('product__description')) return;
        if (!(node.compareDocumentPosition(form) & 4)) return;
        if (clean(node.textContent).indexOf('double-check') !== 0) return;

        var target = node.querySelector('p') || node.querySelector('.rte') || node;
        node.kpNote = true;
        target.innerHTML = NOTE_HTML;
      });
    }

    // A. The price on the button.
    function stamp() {
      var label = blocks.querySelector('form[data-product-form] [data-add-to-cart-text]');
      if (!label) return;

      var bar = blocks.querySelector('.kp-bundles--bar');
      var button = label.closest('[data-add-to-cart]');
      var price = blocks.querySelector('.product__price [data-price]');
      var text = price ? price.textContent.replace(/\s+/g, ' ').trim() : '';

      // Sold out or unavailable: the button says so in the theme's own words.
      var words = clean(label.textContent);
      var gone = !!button && !!words && (words === clean(button.getAttribute('data-lang-sold-out')) || words === clean(button.getAttribute('data-lang-unavailable')));

      var show = !!bar && !bar.hidden && !!text && !!button && !gone;

      if (show) {
        if (label.getAttribute('data-kp-price') !== text) label.setAttribute('data-kp-price', text);
      } else if (label.hasAttribute('data-kp-price')) {
        label.removeAttribute('data-kp-price');
      }
    }

    function refresh() {
      shortenNote();
      stamp();
    }

    // A case type card was pressed: show that card's price under the title at once.
    blocks.addEventListener('click', function (event) {
      var card = event.target.closest ? event.target.closest('.kp-pp__card[data-kp-pp-value]') : null;
      if (!card) return;

      var shown = card.querySelector('.kp-pp__card-price');
      var price = blocks.querySelector('.product__price [data-price]');
      if (!shown || !price || !shown.textContent.trim()) return;

      if (price.textContent.trim() !== shown.textContent.trim()) price.innerHTML = shown.innerHTML;
    }, true);

    // The theme re-writes the price and replaces the button after every change, and the
    // tabs appear a moment after the page does. Run at once each time (no waiting), so the
    // button is right before the screen is next drawn.
    if (window.MutationObserver) {
      new MutationObserver(refresh).observe(blocks, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['hidden', 'disabled']
      });
    }

    refresh();
  }

  function initAll() {
    each(document.querySelectorAll('.product-blocks'), start);
  }

  var style = document.createElement('style');
  style.textContent = '[data-add-to-cart-text][data-kp-price]::after{content:" \u00b7 " attr(data-kp-price)}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
